import React, { useState } from 'react';
import { Container, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import Breadcrumbs from '../CommonElements/Breadcrumbs';
import UserManagementUsersTab from '../Components/UserManagementUsersTab';
import OrganizationManagementTab from '../Components/OrganizationManagementTab';
import FairOrganizationsTab from '../Components/FairOrganizations/FairOrganizationsTab';

function Management() {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="page-body">
      <Breadcrumbs pageTitle="Management" parent="Home" title="Management" />
      <Container fluid>
        <Row>
          <Col sm={12}>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === '1' ? 'active' : ''}
                  onClick={() => toggle('1')}
                  style={{ cursor: 'pointer' }}
                >
                  Organization Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === '2' ? 'active' : ''}
                  onClick={() => toggle('2')}
                  style={{ cursor: 'pointer' }}
                >
                  User Management
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === '3' ? 'active' : ''}
                  onClick={() => toggle('3')}
                  style={{ cursor: 'pointer' }}
                >
                  Fair Organizations
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                {activeTab === '1' && (
                  <OrganizationManagementTab />
                )}
              </TabPane>
              <TabPane tabId="2">
                {activeTab === '2' && <UserManagementUsersTab />}
              </TabPane>
              <TabPane tabId="3">
                {activeTab === '3' && <FairOrganizationsTab />}
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Management;
